@charset "UTF-8";
:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._anchorWrapper_1rqdd_13 {
  width: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  transform: translate(0, -50%);
  pointer-events: none; }
  ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20 {
    border-top: 1px solid rgba(94, 255, 255, 0.7);
    transform: scale(1.00001); }
    ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20._before_1rqdd_23 {
      flex: 1; }
      ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20._before_1rqdd_23._anchorSelected_1rqdd_25, ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20._before_1rqdd_23._anchorHovered_1rqdd_25 {
        border-top: 1px solid rgba(24, 210, 222, 0.7); }
    ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20._after_1rqdd_27 {
      width: 68px; }
      ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20._after_1rqdd_27._anchorSelected_1rqdd_25, ._anchorWrapper_1rqdd_13 ._anchorLine_1rqdd_20._after_1rqdd_27._anchorHovered_1rqdd_25 {
        border-top: 1px solid rgba(24, 210, 222, 0.7); }
  ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 {
    /* anchor handle: ◀︎triangle + ◼️◼️◼️rectangle */
    height: 24px;
    width: 126px;
    pointer-events: auto;
    margin-left: 14px; }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorContent_1rqdd_37 {
      /* ◀︎◼️◼️◼️rectangle */
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      background: rgba(94, 255, 255, 0.7);
      line-height: 24px;
      text-align: left;
      box-sizing: border-box;
      height: 100%;
      cursor: move;
      position: relative; }
      ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorContent_1rqdd_37:before {
        /* ◀︎triangle */
        position: absolute;
        right: 100%;
        content: '';
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-right: 15px solid rgba(94, 255, 255, 0.7); }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 svg {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%); }
      ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 svg * {
        fill: #0a6363; }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorIcon_1rqdd_64 {
      left: 2px;
      width: 13px;
      height: 15px; }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._rightIcon_1rqdd_68 {
      right: 12px; }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorName_1rqdd_70 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 12px;
      -webkit-font-smoothing: antialiased;
      position: absolute;
      left: 19px;
      width: 67px;
      color: #0a6363; }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13._anchorSelected_1rqdd_25 ._anchorContent_1rqdd_37,
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorContent_1rqdd_37:hover {
      background: rgba(24, 210, 222, 0.7);
      color: #2d3034; }
      ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13._anchorSelected_1rqdd_25 ._anchorContent_1rqdd_37 svg *,
      ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorContent_1rqdd_37:hover svg * {
        fill: #2d3034; }
      ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13._anchorSelected_1rqdd_25 ._anchorContent_1rqdd_37:before,
      ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13 ._anchorContent_1rqdd_37:hover:before {
        border-right-color: rgba(24, 210, 222, 0.7); }
    ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13._anchorSelected_1rqdd_25 ._anchorName_1rqdd_70 {
      color: #2d3034; }
  ._anchorWrapper_1rqdd_13 ._anchor_1rqdd_13:hover ._anchorName_1rqdd_70 {
    color: #2d3034; }
